'use client';
import { useEffect, useState } from 'react';
import LpnNo from '@/components/LPN-No';
import { useDispatch, useSelector } from 'react-redux';
import { setPalletTypes } from '@/redux/slices/pallet/palletSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";
import { LpnService } from '@/services/LpnService';
import { RootState } from '@/redux/store';

interface OfflineLpnNoProps {
  projectId?: string;
  isOffline?: boolean;
}

export default function OfflineLpnNo({ projectId, isOffline }: OfflineLpnNoProps) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { activePallet } = useSelector((state: RootState) => state.pallets);

  // useEffect(() => {

  //   loadLpnData();
  // }, [activePallet?.id, dispatch]);
  const loadLpnData = async () => {
    if (activePallet?.id) {
      try {
        setIsLoading(true);
        const response = await LpnService.getLpnNumbers(Number(activePallet.id));
        console.log(response, 'lpn response')
        // if (response.lpnNumbers) {
        //   // Update pallet with LPN numbers
        //   dispatch(setPalletTypes(pallets =>
        //     pallets.map(p =>
        //       p.id === activePallet.id
        //         ? { ...p, lpnNumbers: response.lpnNumbers }
        //         : p
        //     )
        //   ));
        // }
        return response.lpnNumbers
      } catch (error) {
        console.error('Error loading LPN data:', error);
        showErrorToast('Failed to load LPN configuration');
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleOfflineSubmit = async (values: any) => {
    try {
      console.log(values, 'values')
      if (values.type === 'lpnNumbers' && activePallet?.id) {
        const response = await LpnService.createLpnNumbers({
          palletId: Number(activePallet.id),
          lpnNumbers: values.data.data.lpnNumbers
        });

        if (response.lpnNumbers) {
          // Update pallet with new LPN numbers
          // dispatch(setPalletTypes(pallets =>
          //   pallets.map(p =>
          //     p.id === activePallet.id
          //       ? { ...p, lpnNumbers: response.lpnNumbers }
          //       : p
          //   )
          // ));
          showSuccessToast("LPN data saved successfully");
        }
      }
    } catch (error) {
      console.error('Error saving LPN data:', error);
      showErrorToast("Failed to save LPN data");
    } finally {
      setIsLoading(false);
    }
  };
  console.log(isLoading, 'isLoading')
  // if (isLoading) {
  //   return <div>Loading LPN configuration...</div>;
  // }

  return (
    <LpnNo
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
        getLpnNumbers={loadLpnData}
    />
  );
}
